var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',{attrs:{"label":"Link Variable"}},[_c('v-select',{attrs:{"options":_vm.variablesLink,"label":"name","reduce":item => item.key,"placeholder":"Select Global Variable Link"},on:{"input":val => _vm.$emit('change', val)},model:{value:(_vm.variable),callback:function ($$v) {_vm.variable=$$v},expression:"variable"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }